import { Outpayment } from '@/classes/models'

export default class SplitOutpayment {
  /**
   * Create new outpayment and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    if (typeof this.outpayments !== 'undefined') {
      this.outpayments = this.outpayments.map(o => {
        return new Outpayment(o)
      })
    }
  }

  /**
   * @return {Date}
   */
  get createDateTimeUtc () {
    return this._createDateTimeUtc
  }

  /**
   * @param {string} value
   */
  set createDateTimeUtc (value) {
    this._createDateTimeUtc = new Date(value)
  }
}
